export const APIsRoutes = [
  {
    path: "integrations/apis",
    component: () => import("@/domain/Integrations/APIs/presentation/pages/ApisLayout.vue"),
    meta: { requiresAuth: true, permissions: "integrations.read" },
    children: [
      {
        path: "",
        name: "listApis",
        component: () => import("@/domain/Integrations/APIs/presentation/pages/ListApisPage.vue"),
        meta: { requiresAuth: true, permissions: "integrations.read" },
      },
      {
        path: "new",
        name: "newApi",
        component: () => import("@/domain/Integrations/APIs/presentation/pages/NewApiPage.vue"),
        meta: { requiresAuth: true, permissions: "integrations.write" },
      },
      {
        path: ":id",
        name: "editApi",
        component: () => import("@/domain/Integrations/APIs/presentation/pages/EditApiPage.vue"),
        meta: { requiresAuth: true },
      },
    ],
  },
];
